import { useMutation } from '@tanstack/react-query';

import {
  fetchRecordDiagnosis,
  type RecordDiagnosisRequestT,
  type RecordDiagnosisResponseT,
} from '../api/recordDiagnosis.js';
import { diagnosesKeys } from './keys.js';

export interface RecordDiagnosisVariables {
  userId: string;
  data: RecordDiagnosisRequestT;
}

export function useRecordDiagnosisMutation() {
  return useMutation({
    mutationKey: diagnosesKeys.all,
    mutationFn: async ({
      userId,
      data,
    }: RecordDiagnosisVariables): Promise<RecordDiagnosisResponseT> => {
      return await fetchRecordDiagnosis(userId, data);
    },
  });
}
